module.exports = __webpack_public_path__ + "img/Windows_1_MockedUp.bc5545ee.jpg";